<template>
  <div class="option-select">
    <button class="option-select__item"
            v-for="option in options" @click="onSelect(option)">{{ option.label }}</button>
  </div>
</template>

<script>
export default {
  name: 'OptionSelect',
  props: {
    options: {
      type: Array,
      required: true
    }
  },
  methods: {
    onSelect(option) {
      this.$emit('select', option);
    }
  }
}
</script>

<style lang="scss" scoped>
.option-select {
  &__item {
    display: flex;
    width: 100%;
    padding: 16px;
    cursor: pointer;
    transition: ease-in-out 200ms;
    outline: none;

    &:not(:last-child) {
      margin-bottom: 16px;
    }
  }
}
</style>
